import {Solution} from "./solution";
import {Category} from "./category";
import {Workplace} from "./workplace";
import {Malfunction} from "./malfunction";
import {inject, Injectable} from "@angular/core";
import {createClient, SupabaseClient} from "@supabase/supabase-js";
import {LocalStorageService} from "../data-access/local-storage.service";
import {environment} from "../../../environments/environment";
import {from, Observable} from "rxjs";
import {Tables} from "../../services/api.service";

export interface BaseReport {
  id: string;
  created_at: string;
  created_by: string;
  name: string;
  description: string;
  status: MalfunctionStatus;
  current_number: number;
  incident_id: string | null;
  solved_on?: string;
  solved_by?: string;
}

interface ReferenceFields {
  category: Category | null,
  workplace: Workplace | null,
  malfunction: Malfunction | null,
  solution: Solution | null
}

export interface Report extends BaseReport {
  category: string | Category | null;
  workplace: string | Workplace | null;
  malfunction: string | Malfunction | null;
  solution: string | Solution | null;
}

export type FlattenedReport = BaseReport & {
  [K in keyof ReferenceFields]: string | null
}

export enum MalfunctionStatus {
  CREATED = 0,
  RECORDED = 1,
  SOLVED = 2,
  ESCALATED = 3,
  CANCELED = 4,
  DELETED = 5
}

export type StatusLimits = {
  [K in MalfunctionStatus]?: string | null
}

export interface WorkplaceReportFilterOptions {
  rangeStart?: number;
  rangeEnd?: number;
  workplaceFilter?: string[];
  productionLineFilter?: string[];
  statusFilter?: number[];
  searchText?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  minDuration?: string | null;
  maxDuration?: string | null;
  statusLimits?: StatusLimits;
}

export function transformReport(fullReport: Report): FlattenedReport {
  return {
    id: fullReport.id,
    created_at: fullReport.created_at,
    created_by: fullReport.created_by,
    name: fullReport.name,
    description: fullReport.description,
    status: fullReport.status,
    current_number: fullReport.current_number,
    incident_id: fullReport.incident_id,
    solved_on: fullReport.solved_on,
    solved_by: fullReport.solved_by,
    workplace: (fullReport.workplace as Workplace).id,
    category: (fullReport.category as Category).id,
    malfunction: (fullReport.malfunction as Malfunction).id,
    solution: (fullReport.solution as Solution).id

  }

}
